import "./SummaryView.scss";
import { useState } from "react";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import DsbpCommonPopup from "../../../DSBP/DsbpCommonPopup";
import { deleteDashboardView } from "../../../../apis/dashboardApi";
import {
  SUMMARY_DATA,
  SUCCESS_TOAST_LIFE,
  ERROR_TOAST_LIFE,
} from "../../../../constants/dashboardConstants";

const SummaryView = ({ onDelete, summaryData: rawSummaryData, toast }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const moduleId = rawSummaryData?.moduleId;

  /**
   * Transforms raw summary data into formatted structure
   * Reuses SUMMARY_DATA constant and updates counts from incoming data
   */
  const transformSummaryData = (countData) => {
    if (!countData) return SUMMARY_DATA;

    // Mapping of data properties to summary titles
    const dataKeyMap = {
      Alerts: "AlertsCount",
      "Rejected jobs": "RejectedjobsCount",
      "Late approvals": "LateapprovalsCount",
      "Late Fullkits": "LateFullkitCount",
    };

    // Reuse SUMMARY_DATA structure and update counts
    return SUMMARY_DATA.map((item) => ({
      ...item,
      count: countData[dataKeyMap[item.title]] || 0,
    }));
  };

  // Use provided summaryData counts or fall back to default constant
  const summaryData = rawSummaryData?.counts
    ? transformSummaryData(rawSummaryData.counts)
    : SUMMARY_DATA;

  const handleDeleteClick = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = async () => {
    if (!moduleId) {
      toast?.current?.show?.({
        severity: "error",
        summary: "Error",
        detail: "Cannot delete view: Invalid module ID",
        life: ERROR_TOAST_LIFE,
      });
      setShowDeleteConfirm(false);
      return;
    }

    setIsDeleting(true);
    try {
      // Call API to delete dashboard view
      await deleteDashboardView(moduleId);

      // Show success message
      toast?.current?.show?.({
        severity: "success",
        summary: "Success",
        detail: "Summary view deleted successfully",
        life: SUCCESS_TOAST_LIFE,
      });

      // Call parent callback to refresh dashboard
      await onDelete?.();

      setShowDeleteConfirm(false);
    } catch (error) {
      console.error("Error deleting summary view:", error);
      toast?.current?.show?.({
        severity: "error",
        summary: "Error",
        detail: "Failed to delete summary view. Please try again.",
        life: ERROR_TOAST_LIFE,
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  return (
    <div className="summary-cards-container">
      <>
        <Button
          id="removeSummaryBtn"
          icon={isDeleting ? "pi pi-spin pi-spinner" : "pi pi-trash"}
          className="p-button-rounded p-button-text summary-delete-btn"
          onClick={handleDeleteClick}
          title="Remove Summary view"
          aria-label="Remove Summary view"
          disabled={isDeleting}
        />
        <Tooltip target="#removeSummaryBtn" content="Remove Summary view" position="bottom" />
      </>
      <div className="summary-cards">
        {summaryData.map((item, index) => (
          <div key={index} className="summary-card">
            <p className="summary-count" style={{ color: item.color }}>
              {item.count}
            </p>
            <h3 className="summary-title">{item.title}</h3>
            <p className="summary-description">{item.description}</p>
          </div>
        ))}
      </div>

      {/* Delete Confirmation Dialog */}
      <DsbpCommonPopup
        actionHeader="Confirm Deletion"
        dasbpDialog={showDeleteConfirm}
        setDasbpDialog={setShowDeleteConfirm}
        rejectFormData={[{}]}
        onSubmit={handleConfirmDelete}
        deleteButtonShow={true}
        showCancel={true}
        okButtonShow={false}
        yesButtonShow={true}
        submitButtonShow={false}
        disconnectButtonShow={true}
      >
        <>
          Are you sure you want to delete the <strong>Summary view</strong>? This action cannot be
          undone.
        </>
      </DsbpCommonPopup>
    </div>
  );
};

export default SummaryView;
